import React from 'react'
import { useSnapshot } from 'valtio'
import { state } from '../../context/store'
import { motion, AnimatePresence } from 'framer-motion'
// import { ColorSwatchContainer, NavigationControls, CustomPanelRibs, CustomPanelSideLogo, CustomPanelRaceNumber, PriceDisplay, CustomPanelModel, CustomPanelSealant, CustomPanelStitches, PageOptionsConfirm } from './index'
import { ColorSwatchContainer } from './index'
import { OptionPanel, Text, Button, Animator, Row } from '../Blocks'
import styled from 'styled-components'
import { productChoices } from '../../context/productChoices'
import { animations } from '../animations'
import ModeButtonContainer from '../Blocks/ModeButtonContainer'

const Interface = () => {
  const snap = useSnapshot(state.current)
  const productSnap = useSnapshot(productChoices.current)
  const steps = state.current.steps


  const page = snap.currentStep

  return (
    <Wrap id="main-config-options">
      {steps[page].link === "sidePanels" ? (
        <OptionPanel id={state.current.steps[page].link}>
          <ModeButtonContainer section="sidePanels" />
          <ColorSwatchContainer
            // limit={snap.choices.sidePanels.selected.mode}
            limit={snap.status.settingReinforcedSides ? "reinforced" : "regular"}
            section="sidePanels"
          />
          {/* <Text>{ state.current.status.settingReinforcedSides.toString()}</Text> */}
        </OptionPanel>
      ) : null}
      {steps[page].link === "foam" ? (
        <OptionPanel id={state.current.steps[page].link}>
          <ModeButtonContainer section="foam" />
       
          {/* <Text>{ state.current.status.settingReinforcedSides.toString()}</Text> */}
        </OptionPanel>
      ) : null}

      {steps[page].link === "topPanel" ? (
        <OptionPanel id={state.current.steps[page].link}>
          <ColorSwatchContainer section="topPanel" />
        </OptionPanel>
      ) : null}

      {steps[page].link === "ribs" ? (
        <OptionPanel id={state.current.steps[page].link}>
          {snap.initialChoices.ribLimit > 0 ? (
            <ModeButtonContainer section="ribs" />
          ) : null}

          {snap.initialChoices.ribLimit > 0 ? (
            <>
              {snap.choices.ribs.selected.mode === 'no' ? (
                <Text>No ribs currently selected</Text>
              ) : null}
              {snap.choices.ribs.selected.mode === 'single' ? (
                <ColorSwatchContainer section="ribs" />
              ) : null}
            </>
          ) : (
            <Text>This seat cover doesn't have ribs</Text>
          )}
        </OptionPanel>
      ) : null}

      {steps[page].link === "raceNumber" ? (
        <OptionPanel id={state.current.steps[page].link}>
          <ModeButtonContainer section="raceNumber" />

          {/* <CustomPanelRaceNumber /> */}
        </OptionPanel>
      ) : null}
      {steps[page].link === "superBadge" ? (
        <OptionPanel id={state.current.steps[page].link}>
          <ModeButtonContainer section="superBadge" />

          {/* <CustomPanelSuperBadge /> */}
        </OptionPanel>
      ) : null}

      {steps[page].link === "topLogo" ? (
        <OptionPanel id={state.current.steps[page].link}>
          {snap.initialChoices.logoSize === 'none' ? (
            <Text>This seat cover doesn't have a top logo.</Text>
          ) : (
            <ModeButtonContainer section="topLogo" />
          )}
        </OptionPanel>
      ) : null}

      {steps[page].link === "sideLogo" ? (
        <OptionPanel id={state.current.steps[page].link}>
          <ModeButtonContainer section="sideLogos" />
        </OptionPanel>
      ) : null}

      {steps[page].link === "sealant" ? (
        <OptionPanel id={state.current.steps[page].link}>
          <ModeButtonContainer section="sealant" />
          {snap.choices.sealant.selected.mode === 'sealant' ? (
            <Animator motion={animations.slideUp('spring', 0.8, 0.5)}>
              <Text> Please allow 1-5 days for sealed seats to ship.</Text>
            </Animator>
          ) : null}
        </OptionPanel>
      ) : null}
      {steps[page].link === "confirm" ? (
        <OptionPanel id={state.current.steps[page].link}>
          <Button
            handleClick={() => {
              state.current.modal.open = true
              state.current.modal.orderSummary = true
            }}
          >
            Review Choices
          </Button>
        </OptionPanel>
      ) : null}
    </Wrap>
  )
}

export default Interface

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 100%;
  margin-top: 20px;
  gap: 10px;

  @media (width > 800px) {
    margin-top: 0px;
    align-items: center;
  }

  & .heading {
    text-transform: uppercase !important;
    font-size: 22px;
    margin-block: 0px;
    width: 100%;
    text-align: center;
    line-height: 1em;

    @media (width > 800px) {
      font-size: 26px;
    }
  }
`

const InnerWrap = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 12px !important;
  align-items: start !important;
  gap: 20px !important;
  font-weight: 700 !important;
  letter-spacing: -1px !important;
  width: 100vw;

  @media (width > 800px) {
    align-items: center !important;
    justify-content: center;
  }
`
